module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="left-info"></div>\n<div class="center-info">\n    ';
 if (inGroup) { ;
__p += '\n    <div class="vertical-line"></div>\n    <label>Title: <input type="text" class="name-input tour-experience-name" ' +
__e( spectator ? "disabled" : "" ) +
'></label>\n    ';
 } ;
__p += '\n\n    <div class="multi-scene-options hidden"></div>\n\n    <div class="template-options"></div>\n\n</div>\n\n<div class="right-info experience-sync-state-region">\n';
 if(isNewDashboardExperience) { ;
__p += '\n    <span class= "new-dashboard-note" > <strong> Note: </strong> To Publish/copy code please click on Preview and Publish </span>\n';
 } ;
__p += '\n\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/editor/ExperienceOptionsView.tpl
// module id = 2946
// module chunks = 0